import { createContext, useContext } from 'react'

export enum AuthType {
  LogIn = 'log_in',
  SignUp = 'sign_up',
}

const AuthTypeContext = createContext<AuthType>(AuthType.LogIn)
export const AuthTypeProvider = AuthTypeContext.Provider

export const useAuthType = () => {
  return useContext(AuthTypeContext)
}
